import React, { useState, useEffect } from "react";
import { Navbar as BootstrapNavbar, Nav, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../../assets/css/general/myNavbar/MyNavbar.css";
import { FaGraduationCap, FaSignInAlt, FaHandshake } from "react-icons/fa";
import VerificationModal from "../../../components/student/verificationModal/VerificationModal";

const MyNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("student");

  const navigate = useNavigate();
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  // Close mobile menu on route change
  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  // ✅ Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Check if link is active
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <>
      <BootstrapNavbar
        expand="lg"
        variant="dark"
        className={`mnb-custom-navbar ${scrolled ? 'scrolled' : ''}`}
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <div className="container-fluid px-4">
          <div className="mnb-navbar-wrapper">

            {/* LOGO */}
            <Link to="/" className="mnb-logo-brand">
              <div className="mnb-logo-icon-wrapper">
                <FaGraduationCap className="mnb-logo-icon" />
              </div>
              <span className="mnb-logo-text">Student Support Hub</span>
            </Link>

            <BootstrapNavbar.Toggle aria-controls="navbar-nav" />

            <BootstrapNavbar.Collapse id="navbar-nav">
              <Nav className="mnb-navbar-center">
                <Nav.Link as={Link} to="/home" className={`mnb-nav-link-custom ${isActive('/home')}`}>Home</Nav.Link>
                <Nav.Link as={Link} to="/solutions" className={`mnb-nav-link-custom ${isActive('/solutions')}`}>Solutions</Nav.Link>
                <Nav.Link as={Link} to="/donor" className={`mnb-nav-link-custom ${isActive('/donor')}`}>Donor</Nav.Link>
                <Nav.Link as={Link} to="/ngo" className={`mnb-nav-link-custom ${isActive('/ngo')}`}>NGO</Nav.Link>
                <Nav.Link as={Link} to="/blogs" className={`mnb-nav-link-custom ${isActive('/blogs')}`}>Blogs</Nav.Link>
                <Nav.Link as={Link} to="/about" className={`mnb-nav-link-custom ${isActive('/about')}`}>About</Nav.Link>
                <Nav.Link as={Link} to="/contact" className={`mnb-nav-link-custom ${isActive('/contact')}`}>Contact</Nav.Link>
              </Nav>
            </BootstrapNavbar.Collapse>

            {/* RIGHT BUTTONS */}
            <div className="mnb-navbar-right">
              <Button
                className="mnb-nav-btn mnb-btn-Login"
                onClick={() => navigate("/student/login")}
              >
                <FaSignInAlt className="mnb-btn-icon" />
                <span>Student</span>
              </Button>

              <Button
                className="mnb-nav-btn mnb-btn-NGO"

                onClick={() => navigate("/ngo-auth")}


              >
                <FaHandshake className="mnb-btn-icon" />
                <span>NGO</span>
              </Button>
            </div>

          </div>
        </div>
      </BootstrapNavbar>

      {/* Verification Modal */}
      <VerificationModal
        show={showModal}
        onClose={() => setShowModal(false)}
        type={modalType}
      />
    </>
  );
};

export default MyNavbar;